import { useMemo, useState } from "react";
import {
  FaBars,
  FaBox,
  FaSignOutAlt,
  FaStar,
  FaUser
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FiLogIn } from "react-icons/fi";
import { GoHeartFill } from "react-icons/go";
import { PiShoppingCartSimpleFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/png/logo_tk (2).png";
import { actions } from "../../redux/slices/auth/authSlice";
import { setCart } from "../../redux/slices/cart/cartSlice";
import { setUser } from "../../redux/slices/user/userSlice";
import { dispatch } from "../../redux/store";
import { Sheet } from "../shared/Sheet";

const DeliveryButton = ({
  setLocationsOpen,
  setLoginModal,
}: {
  setLocationsOpen: any;
  setLoginModal?: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showSignOutDialog, setShowSignOutDialog] = useState(false);
  const { selectedBusinessLocation } = useSelector(
    (state: any) => state.businessLocation
  );
  const { auth } = useSelector((state: any) => state.auth);
  const { cart } = useSelector((state: any) => state.cart);

  const handleSignOut = async () => {
    await dispatch(actions.logout());
    localStorage.removeItem("authToken");
    setShowSignOutDialog(false);
    dispatch(setCart([]));
    dispatch(setUser(null));
    navigate("/");
  };
  const navigate = useNavigate();

  useMemo(() => {
    setIsOpen(false);
  }, [auth]);
  return (
    <div className="rounded-full lg:bg-[#333333] cursor-pointer flex justify-between items-center lg:border-[1px] lg:px-[10px] border-[#252525] xl:px-[12px] lg:py-[2px] xl:py-[3px] lg:hidden xl:min-w-[150px]">
      <div
        onClick={() => setLocationsOpen(true)}
        className="flex gap-2 items-center h-full lg:w-full justify-center w-1/4"
      >
        <FaLocationDot
          className="text-white lg:text-black min-w-4 size-4 shrink-0 md:size-6"
          color="#333333"
        />
        <div className="font-semibold text-gray-700 text-xs md:text-md">
          {selectedBusinessLocation?.businessName ?? "Delivery Location"}
        </div>
      </div>
      <div className="h-full lg:hidden flex justify-center w-1/3">
        <img onClick={() => navigate("/")} className="h-[50px] object-contain" src={Logo} alt="logo" />
      </div>
      <div className="w-1/6 flex justify-end items-center">
        <div
          onClick={() => setIsOpen(true)}
          className="w-9 min-h-9 rounded-full flex lg:hidden items-center justify-center"
        >
          <FaBars className="h-full size-7" color="#333" />
        </div>
      </div>
      <Sheet
        direction="right"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        children={
          <div className="w-full mt-5 flex h-full relative flex-col gap-3 py-1 z-10">
            {auth ? (
              <>
                <Link
                  to="/profile"
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <FaUser size={20} className=" basis-[15%] mr-2" />
                  My Profile
                </Link>

                <Link
                  to="/cart"
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <div className="relative flex justify-center basis-[15%] mr-2">
                    {cart.length > 0 && (
                      <div className="absolute top-0 right-2 bg-red-500 text-white rounded-full text-xs font-semibold w-4 h-4 flex items-center justify-center">
                        {cart.length}
                      </div>
                    )}
                    <PiShoppingCartSimpleFill size={24} className="" />
                  </div>
                  My cart
                </Link>

                <Link
                  to="/order"
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <FaBox size={17} className="mr-2 basis-[15%]" />
                  My Orders
                </Link>

                <Link
                  to="/reviews"
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <FaStar size={20} className="mr-2 basis-[15%]" />
                  My Reviews
                </Link>

                <Link
                  to="/favorite"
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <GoHeartFill size={20} className="mr-2 basis-[15%]" />
                  My Wishlist
                </Link>

                <button
                  onClick={() => setShowSignOutDialog(true)}
                  className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                >
                  <FaSignOutAlt className="mr-2 basis-[15%]" />
                  Sign Out
                </button>
              </>
            ) : (
              <div
                onClick={() => setLoginModal(true)}
                className="flex items-center w-full px-4 py-2 text-md text-gray-700 hover:bg-gray-100 hover:opacity-70 "
              >
                <FiLogIn className="mr-2 basis-[15%]" size={28} />
                Login
              </div>
            )}
          </div>
        }
      />
      {showSignOutDialog && (
        <div className="fixed z-[1002] inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
            <h2 className="text-xl font-semibold mb-4">Sign Out</h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to sign out? You'll need to sign in again to
              access your account.
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowSignOutDialog(false)}
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleSignOut}
                className="px-4 py-2 text-sm font-medium text-red-600 bg-red-100 hover:bg-red-200 rounded-md"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeliveryButton;
